import React from 'react';
import RadioCardGroup from 'components/Fragments/RadioCardGroup/RadioCardGroup';
import { ReactComponent as ChevronRight } from 'style/_assets/icons/chevron-right.svg';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './AccountOptionsLinks.scss';

const IconTransferMoney = () => (
  <div className="icon-transfer-money radio-icon" />
);

const IconManageCard = () => <div className="icon-manage-card radio-icon" />;

export const AccountOptionsLinks = ({
  datatestid,
  handleAccountOptionsClick,
  ...props
}) => {
  const { RadioCard } = RadioCardGroup;
  return (
    <RadioCardGroup
      onChange={handleAccountOptionsClick}
      radioGroupClass="format100"
    >
      {!props.hideTransferMoney && (
        <RadioCard
          datatestid={`${datatestid}-transferMoney-radio`}
          value="transferMoney"
          cardType="fullWidth no-margin-top"
          icon={IconTransferMoney}
        >
          <FlexContainer className="justify-between align-items-center">
            <Label>Move money</Label>
            <ChevronRight aria-label={'ChevronRight'} />
          </FlexContainer>
        </RadioCard>
      )}
      {!props.hideManageCard && (
        <RadioCard
          datatestid={`${datatestid}-manageCard-radio`}
          value="manageCard"
          cardType="fullWidth"
          icon={IconManageCard}
        >
          <FlexContainer className="justify-between align-items-center">
            <Label>Manage card</Label>
            <ChevronRight aria-label={'ChevronRight'} />
          </FlexContainer>
        </RadioCard>
      )}
    </RadioCardGroup>
  );
};
